import type { FC, SVGProps } from "react";

const IconGallery: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M11.6667 1H2.33333C1.59695 1 1 1.59695 1 2.33333V11.6667C1 12.403 1.59695 13 2.33333 13H11.6667C12.403 13 13 12.403 13 11.6667V2.33333C13 1.59695 12.403 1 11.6667 1Z" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5.00033 6.33268C5.73671 6.33268 6.33366 5.73573 6.33366 4.99935C6.33366 4.26297 5.73671 3.66602 5.00033 3.66602C4.26395 3.66602 3.66699 4.26297 3.66699 4.99935C3.66699 5.73573 4.26395 6.33268 5.00033 6.33268Z" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13 9.00045L10.9427 6.94312C10.6926 6.69315 10.3536 6.55273 10 6.55273C9.64645 6.55273 9.30737 6.69315 9.05733 6.94312L3 13.0004" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconGallery;
